import styled from 'styled-components';

export const WrapperDiv = styled.div`
  width: 100%;
  .error {
    font-size: 0.9em;
    color: var(--ion-color-danger);
  }
  
  ion-skeleton-text {
    width: 100%;
    margin-top: 1rem;
  }

  .date-time-button {
    flex: 1 0 auto;
    margin: 0.8rem 0;
    
    &.light {
        &::part(native) {
        flex: 1 0 auto;
        background: var(--ion-color-light);
        color: var(--ion-color-light-contrast);
      }
    }
    &.dark {
        &::part(native) {
        flex: 1 0 auto;
        background: var(--ion-color-light);
        color: var(--ion-color-light-contrast);
      }
    }

    .select-date-label, .select-time-label {
      color: var(--ion-color-medium);
    }
  }
`;
